<div class="flex flex-column flex-wrap backPanel border-round-3xl px-5 mt-5 py-5 align-items-center sm:align-items-start">

  <div class="mb-5">
    <p-button label="Genera Competenza" (onClick)="generaCompetenza()" />
  </div>

  <p-table [value]="competenzeList" class="w-full">
    <ng-template pTemplate="header">
        <tr>
            <th>Anno</th>
            <th class="text-right">Quota</th>
            <th class="text-right">Quota Ridotta</th>
            <th class="text-right">Percentuale Riduzione</th>
            <th class="text-right">Spese Amministrative</th>
            <th class="text-center">Anni Riduzione</th>
            <th class="text-center">Data Morosità</th>
            <th class="text-center">Modifica</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-competenza let-i="rowIndex">
        <tr>
            <td class="font-bold">{{ competenza.anno }}</td>
            <td class="text-right white-space-nowrap">{{ competenza.quota ? competenza.quota.toFixed(2) : '0.00' }} €</td>
            <td class="text-right">{{ competenza.quotaRidotta ? competenza.quotaRidotta.toFixed(2) : '0.00' }} €</td>
            <td class="text-right">{{ competenza.percentualeRiduzione ? competenza.percentualeRiduzione.toFixed(2) : '0.00' }} %</td>
            <td class="text-right">{{ competenza.speseAmministrative ? competenza.speseAmministrative.toFixed(2) : '0.00' }} €</td>
            <td class="text-center">{{ competenza.anniRiduzione || 0 }}</td>
            <td class="text-center">{{ competenza.dataMorosita | date: 'dd/MM/yyyy' }}</td>

            <td class="flex justify-content-center">
              @if(!competenza.speseApplicate){
                <p-button
                  icon="pi pi-pencil"
                  size="small"
                  pTooltip="Modifica"
                  (onClick)="showDialogModifica(i)"
                />
              }@else {
                <span style="visibility: hidden;">
                  <p-button icon="pi pi-pencil" size="small" />
                </span>
              }
            </td>

        </tr>
    </ng-template>
  </p-table>

</div>

<p-dialog [header]="titleDiaolg" [modal]="true" [(visible)]="visible">

    @if(bodyDiaolog){
      <span class="p-text-secondary block mb-5">Compila le nuove statistiche.</span>
    }@else {
      <span class="p-text-secondary block mb-5">Modifica le statistiche dell'anno {{ competenzaForm.get('anno')?.value }}.</span>
    }

    <form [formGroup]="competenzaForm">

      @if(bodyDiaolog){
        <div class="flex align-items-center gap-6 mb-5">
          <label for="anno" class="font-semibold w-6rem">Anno</label>
          <p-inputNumber
            inputId="anno"
            formControlName="anno"
            autocomplete="off"
            [inputStyle]="{ 'text-align': 'right' }"
          />
        </div>
      }

      <div class="flex align-items-center gap-6 mb-3">
        <label for="quota" class="font-semibold w-6rem">Quota</label>
        <p-inputNumber
          inputId="quota"
          formControlName="quota"
          mode="decimal"
          [minFractionDigits]="2"
          autocomplete="off"
          suffix=" €"
          [inputStyle]="{ 'text-align': 'right' }" />
      </div>

      <div class="flex align-items-center gap-6 mb-5">
          <label for="percentualeRiduzione" class="font-semibold w-6rem">Percentuale Riduzione</label>
          <p-inputNumber
            inputId="percentualeRiduzione"
            formControlName="percentualeRiduzione"
            mode="decimal"
            [minFractionDigits]="2"
            autocomplete="off"
            suffix=" %"
            [inputStyle]="{ 'text-align': 'right' }" />
      </div>

      <div class="flex align-items-center gap-6 mb-5">
        <label for="speseAmministrative" class="font-semibold w-6rem">Spese Amministrative</label>
        <p-inputNumber
          inputId="speseAmministrative"
          formControlName="speseAmministrative"
          mode="decimal"
          [minFractionDigits]="2"
          autocomplete="off"
          suffix=" €"
          [inputStyle]="{ 'text-align': 'right' }" />
      </div>

      <div class="flex align-items-center gap-6 mb-5">
        <label for="anniRiduzione" class="font-semibold w-6rem">Anni Riduzione</label>
        <p-inputNumber
          inputId="anniRiduzione"
          formControlName="anniRiduzione"
          autocomplete="off"
          [inputStyle]="{ 'text-align': 'right' }"
        />
      </div>

      <div class="flex align-items-center gap-6 mb-5">
        <label for="dataMorosita" class="font-semibold w-6rem">Data Morosità</label>
        <p-calendar
          inputId="dataMorosita"
          formControlName="dataMorosita"
          appendTo="body"
          autocomplete="off"
          [inputStyle]="{ 'text-align': 'right' }"
          dateFormat="dd/mm/yy"
        />
      </div>

    </form>

    <div class="flex justify-content-end gap-2">
        <p-button label="Annulla" severity="danger" (onClick)="closeDialogModifica()" />
        <p-button [label]="bodyDiaolog ? 'Genera' : 'Salva'" (onClick)="bodyDiaolog ? genera() : salvaModifica()" [disabled]="competenzaForm.invalid" />
    </div>
</p-dialog>

<p-toast position="bottom-center"></p-toast>
